import React from 'react'
import Layout from '../../components/layout/Layout'
import AssignJobsTable from '../../elements/tables/assignJobs/AssignJobsTable'

export default function AssignJobs() {
  return (
    <div>
      <Layout>
        <AssignJobsTable />
      </Layout>
    </div>
  )
}
